<ngx-spinner ><p style="color: white" > Cargando... </p></ngx-spinner>
<router-outlet></router-outlet>

